import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ManualChargeDetailContMain from "presentation/view/container/ManualCharge/ManualChargeDetailContMain";

CommonEntrypoint(<ManualChargeDetailContMain/>)